import DashboardLayout from "@/layouts/dashboard-layout";
import "./styles.scss";
import { useNavigate, useParams } from "react-router-dom";
import { Icon } from "@/components";
import truncateString from "@/utils/truncateString";
import { useAppSelector } from "@/redux/hooks";
import { Activity } from "@/types/activity";
import { useEffect } from "react";
import { useCompletionContext } from "@/contexts/PointsContext";
import { useAuth } from "@/contexts/auth-context";
import { activityLessonFetch } from "@/redux/slice/activity/lessons";
import { useAppDispatch } from "@/redux/hooks";
import { useLanguageContext } from "@/contexts/language-context";

export const Brief = () => {
  const dispatch = useAppDispatch();
  const { values } = useLanguageContext();
  const { token } = useAuth();
  const { lesson_id, level_id } = useParams();
  const navigate = useNavigate();
  const { setPoints } = useCompletionContext();
  const { data, error, loading } = useAppSelector(
    (state) => state.activityLesson
  );
  const activity = data && data.find((a: Activity) => a.id === lesson_id);
  const item = activity;

  useEffect(() => {
    setPoints(item?.points);
  }, [data, item]);

  useEffect(() => {
    if (token && level_id) {
      dispatch(
        activityLessonFetch({
          token,
          level_id,
          language: values.initialLanguage,
        })
      );
    }
  }, []);


  return (
    <DashboardLayout>
      <div className="brief">
        <div className="brief__content">
          <h1 className="brief__title">Lesson Brief</h1>
          <h2 className="brief__package-title">{item?.title}</h2>
          <p className="brief__lesson-exercise">
            Lesson{"  "}
            {item?.lessonNumber} ・ {item?.exerciseCount} Exercise
          </p>

          <p className="brief__base-text">Your Learning Goal</p>

          <p className="brief__base-text">
            Description:{" "}
            <span className="brief__goal">{item?.description}</span>
          </p>

          {item?.points.map((each: string, index: number) => (
            <div key={index} className="brief__con">
              <Icon name="checkGray" />
              <p className="brief__point">{truncateString(each, 80)}</p>
            </div>
          ))}
        </div>

        <div className="brief__button-container">
          <button
            onClick={() =>
              navigate(
                `/activity/level/${level_id}/lesson/${lesson_id}/brief/activity-loading`
              )
            }
            className="brief__button"
          >
            Start
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
};
